import React from 'react';
import { Route } from 'react-router';
import CategorySales from 'pages/Reports/Sales/CategorySales';
import CollectedBy from 'pages/Reports/Sales/CollectedBy';
import Discounts from 'pages/Reports/Sales/Discounts';
import Gratuity from 'pages/Reports/Sales/Gratuity';
import GrossProfit from 'pages/Reports/Sales/GrossProfit';
import Invoices from 'pages/Reports/Invoices';
import ItemSales from 'pages/Reports/Sales/ItemSales';
import ModifierSales from 'pages/Reports/Sales/ModifierSales';
import PaymentMethods from 'pages/Reports/Sales/PaymentMethods';
import Report from 'pages/Reports/Report';
import ReportSummary from 'pages/Reports/Sales/ReportSummary';
import SalesType from 'pages/Reports/Sales/SalesType';
import ServedBy from 'pages/Reports/Sales/ServedBy';
import Shift from 'pages/Reports/Shift';
import Taxes from 'pages/Reports/Sales/Taxes';
import Transaction from 'pages/Reports/Transaction';
import createCustomRoute from 'hocs/createCustomRoute';

const ReportRoutes = createCustomRoute('ReportRoutes', props => (
  <Route {...props} component={Report}>
    <Route path="sales">
      <Route path="summary" component={ReportSummary} />
      <Route path="gross_profit" component={GrossProfit} />
      <Route path="payment_methods" component={PaymentMethods} />
      <Route path="sales_type" component={SalesType} />
      <Route path="item_sales" component={ItemSales} />
      <Route path="category_sales" component={CategorySales} />
      <Route path="modifier_sales" component={ModifierSales} />
      <Route path="discounts" component={Discounts} />
      <Route path="taxes" component={Taxes} />
      <Route path="gratuity" component={Gratuity} />
      <Route path="staff" component={CollectedBy} />
      <Route path="server" component={ServedBy} />
    </Route>
    <Route path="transactions" component={Transaction} />
    <Route path="shifts" component={Shift} />
    <Route path="invoices" component={Invoices} />
  </Route>
));

export default ReportRoutes;
